import { styled } from 'parkdepot-shared/theme'

export const CardBodyMainContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale400,
    maxWidth: '190px'
}))

export const CardBodyMainContainerTitle = styled('p', ({ $theme }) => ({
    ...$theme.typography.LabelSmall,
    margin: 0,
    color: $theme.colors.black
}))

export const CardBodyMainContainerSubtitle = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    margin: 0,
    color: $theme.colors.black
}))

export const CardBodyMainInfoText = styled('p', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    margin: 0,
    color: $theme.colors.black
}))

export const CardExtraInfo = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    margin: 0,
    color: $theme.colors.black
}))

export const FullyWhitelistedCardExtraInfoTitle = styled('p', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    color: $theme.colors.black,
    margin: 0
}))

export const CardExtraWarningInfo = styled('p', ({ $theme }) => ({
    ...$theme.typography.LabelXSmall,
    color: $theme.colors.red700,
    margin: 0
}))

export const CountdownTextContainer = styled('div', () => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    alignItems: 'center'
}))

// free order card
export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    textAlign: 'center',
    color: $theme.colors.positive700,
    margin: 0
}))

export const Subtitle = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    margin: 0,
    textAlign: 'center'
}))

export const Icon = styled('i', ({ $theme }) => ({
    fontSize: $theme.sizing.scale900,
    color: $theme.colors.positive700
}))

export const Time = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0,
    textAlign: 'center'
}))
